// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2iGUr","productName":"Table_productName__2uzIF"};